import cvDownload from '../../../mixins/cvDownload';
import toolFunction from './tools-functions';
import {store} from '../../../store/store';

export default {
  mixins: [cvDownload, toolFunction],
  data() {
    return {
      cv: 0,
      wait: true,
      invalidTools: false,
      writeExperience: true,
      writeEducation: true,
      educationCount: this.$store.state.cv.educations.length,
      waitEducation: true,
      key: 1,
      parent_ul: null,
      store_name: '',
      brs: {
        type: null,
        type_id: null,
        cv_id: null,
        count: null,
        page: null
      },
      sib: 0,
      MIX_LINE_INTELLECT_BR: process.env.MIX_LINE_INTELLECT_BR,
      selected_elements: [],
      renderTemplate: true,
      waitForAjax: false,
    };
  },
  mounted() {
    this.$parent.getData().then(changed => {
      if (changed) {
        this.checkState('tmpEducation', 'writeEducation');
        this.checkState('tmpExperience', 'writeExperience');
      }

      if(!this.$store.getters.cv_name && this.$store.getters.user.name){
        this.$store.commit('cv_name',this.$store.getters.user.name)
      }

      if(!this.$store.getters.cv_surname && this.$store.getters.user.name){
        this.$store.commit('cv_surname',this.$store.getters.user.surname)
      }

      if(!this.$store.getters.cv_email && this.$store.getters.user.email){
        this.$store.commit('cv_email',this.$store.getters.user.email)
      }

    });

    if (this.$route.params.check_key !== undefined) {
      this.$store.commit('modalBuyLoad', true);
    }
    if (this.$route.name.match(/cv-create/)) {
      this.imageSetDefault();
    }



  },
  computed: {
    tmpExperience() {
      return this.$store.state.cv.tmpExperience;
    },
    tmpEducation() {
      return this.$store.state.cv.tmpEducation;
    }
  },
  watch: {
    '$store.state.cv.date'(to, from) {
      if (to === null) to = '';
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_date', to);
      }
    },
    '$store.state.cv.name'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_name', to);
      }
    },
    '$store.state.cv.surname'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_surname', to);
      }
    },
    '$store.state.cv.photo'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_photo', to);
      }
    },
    '$store.state.cv.career_objective'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_career_objective', to);
      }
    },
    '$store.state.cv.email'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_email', to);
      }
    },
    '$store.state.cv.phone'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_phone', to);
      }
    },
    '$store.state.cv.address'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_address', JSON.stringify(to));
      }
    },
    '$store.state.cv.jobStack.title'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_job_stack', JSON.stringify(this.$store.state.cv.jobStack));
      }
    },
    '$store.state.cv.jobStackCurrency'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_job_stack_currency', JSON.stringify(to));
      }
    },
    '$store.state.cv.jobStack.sallery'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_job_stack', JSON.stringify(this.$store.state.cv.jobStack));
      }
    },
    '$store.state.cv.hasExperience'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('hasExperience', to * 1);
      }
    },
    '$store.state.cv.experiences'(to, from) {

      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_experiences', JSON.stringify(to));
      }
    },
    '$store.state.cv.educations'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_educations', JSON.stringify(to));
      }
    },
    '$store.state.cv.cvLanguages'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_languages', JSON.stringify(to));
      }
    },
    '$store.state.cv.cvProfessions'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_professions', JSON.stringify(to));
      }
    },
    '$store.state.cv.cvCitizens'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_citizens', JSON.stringify(to));
      }
    },
    '$store.state.cv.cvSkills'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_skills', JSON.stringify(to));
      }
    },
    '$store.state.cv.cvHobbies'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_hobbies', JSON.stringify(to));
      }
    },
    '$store.state.cv.hasSocial'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('hasSocial', to * 1);
      }
    },
    '$store.state.cv.tmpSocial.url'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpSocial', JSON.stringify(this.$store.state.cv.tmpSocial));
      }
    },
    '$store.state.cv.cvSocials'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_socials', JSON.stringify(to));
      }
    },
    '$store.state.cv.hasHobby'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('hasHobby', to * 1);
      }
    },
    '$store.state.cv.hasAchievement'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('hasAchievement', to * 1);
      }
    },
    '$store.state.cv.hobby'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_hobby', to);
      }
    },
    '$store.state.cv.hobbies'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_hobbies', JSON.stringify(to));
      }
    },
    /* start  tmpExperience*/
    'tmpExperience.start'(to, from) {
      this.checkState('tmpExperience', 'writeExperience');
      if (to === null) to = '';
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpExperienceStart', to);
      }
    },
    'tmpExperience.end'(to, from) {
      this.checkState('tmpExperience', 'writeExperience');
      if (to === null) to = '';
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpExperienceEnd', to);
      }
    },
    'tmpExperience.location.address'(to, from) {
      this.checkState('tmpExperience', 'writeExperience');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpExperienceLocation', JSON.stringify(this.tmpExperience.location));
      }
    },
    'tmpExperience.specialization'(to, from) {
      this.checkState('tmpExperience', 'writeExperience');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpExperienceSpecialization', JSON.stringify(to));
      }
    },
    'tmpExperience.company'(to, from) {
      this.checkState('tmpExperience', 'writeExperience');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpExperienceCompany', to);
      }
    },
    'tmpExperience.description'(to, from) {
      this.checkState('tmpExperience', 'writeExperience');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpExperienceDescription', to);
      }
    },
    /* end  tmpExperience*/
    /* start tmpEducation */
    'tmpEducation.start'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (to === null) to = '';
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationStart', to);
      }
    },
    'tmpEducation.end'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (to === null) to = '';
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationEnd', to);
      }
    },
    'tmpEducation.location.address'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationLocation', JSON.stringify(this.tmpEducation.location));
      }
    },
    'tmpEducation.specialization'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationSpecialization', JSON.stringify(to));
      }
    },
    'tmpEducation.university'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationUniversity', to);
      }
    },
    'tmpEducation.description'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationDescription', to);
      }
    },
    'tmpEducation.faculty'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationFaculty', to);
      }
    },
    'tmpEducation.degree'(to, from) {
      this.checkState('tmpEducation', 'writeEducation');
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('tmpEducationDegree', JSON.stringify(to));
      }
    },
    /* end  tmpEducation*/

    '$store.state.cv.cvTheme'(to) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('cv_theme', JSON.stringify(to));
      }
    },
    '$store.state.cv.achievement'(to, from) {
      if (this.$route.name.match(/cv-create/)) {
        localStorage.setItem('achievement', JSON.stringify(to));
      }
    },
  },
  methods: {
    correctDate(date, data = false) {
      if (!date) return '';
      try {
        date.getMonth();
      } catch (error) {
        if (date) {
          date = new Date(date);
        }
      }
      if (!data) {
        var mm = date.getMonth() + 1;
        var dd = date.getDate();
        var yyyy = date.getFullYear();
        if (mm < 10) {
          mm = `0${mm}`;
        }
        if (dd < 10) {
          dd = `0${dd}`;
        }
        return `${dd}.${mm}.${yyyy}`;
      } else {
        if (date != null && date && data.month) {
          var mm = date.getMonth() + 1;
          var yyyy = date.getFullYear();
          if (mm < 10) {
            mm = `0${mm}`;
          }
          return `${yyyy}.${mm}`;
        }
        return false;
      }
    },
    checkState(field, variable) {
      var show = false;
      for (let item in this[field]) {
        if (this[field][item] instanceof Object) {
          if (this[field][item].id || item == 'start' || item == "end"
            || item == "location" && this[field][item]['address']) {
            show = true;
            break;
          }
        } else {
          if (this[field][item]) {
            show = true;
            break;
          }
        }
      }
      this[variable] = show;
    },
    convertSocial(url, icon = false) {
      if (this.$store.state.cv.tmpSocial.icon || icon) {
        url = url.split('/');
        return `/${url[url.length - 1]}`;
      } else {
        return url;
      }
    },
    CvValidate() {
      const rules = this.$store.state.cv.validation;
      this.wait = true;
      var count = 0;
      for (const item of rules) {
        count++;
        let rule = {
          name: item.rules,
          rules: item.rules
        };
        this.$validator.attach(rule);
        let value = false;
        if (item.name.indexOf('|') === -1) {
          value = this.$store.state.cv[item.name];
        } else {
          item.name.split('|').forEach(key => {
            if (!value) {
              value = this.$store.state.cv[key];
            } else {
              value = value[key];
            }
          });
        }
        this.$validator.validate(item.rules, value)
          .then(res => {
            count--;
            if (!res && !this.invalidTools) {
              this.invalidTools = true;
              this.addInvalidClass(item.blockId);
              this.$refs.tools.openMobileTools();
            }

            if (!count) {
              this.wait = false;
            }
          });
      }
    },
    addInvalidClass(blockId) {
      let block = document.getElementById(
        blockId
      );
      if (block !== null) {
        if (!block.closest(".block").classList.contains("invalid")) {
          if (
            !block
              .closest(".all_form_block")
              .classList.contains("active")
          ) {
            block.click();
          }
          block.closest(".block").classList.add("invalid");
          setTimeout(() => {
            this.invalidTools = false;
            block.closest(".block").classList.remove("invalid");
          }, 2500);
        }
        this.$scrollTo(`#${blockId}`, {
          offset: -65
        });
      }
    },
    save() {
      this.invalidTools = false;
      this.CvValidate();
      this.educationValidation();
      this.experienceValidation();
      this.socialValidation();

      var waitInterval = setInterval(() => {
        if (!this.wait) {
          clearInterval(waitInterval);
          if (!this.invalidTools) {
            if (this.$store.getters.authUser) {
              NProgress.start();
              const CV = this.generateCv();
              this.$http({
                method: "post",
                url: "/api/cv",
                data: CV,
              }).then(res => {
                localStorage.clear();
                this.createdOrUpdated(res.data.cv, res.data.type, 'created');
                this.saveTemplateImgAndPdf(res.data.cv);
              });
            } else {
              this.$store.commit('fromSaveButton', true);
              this.$store.commit('loginModal', true);
            }
          }
        }
      }, 1);
    },
    edit(cv) {
      this.invalidTools = false;
      this.CvValidate();
      this.educationValidation();
      this.experienceValidation();
      this.socialValidation();

      var waitInterval = setInterval(() => {
        if (!this.wait) {
          clearInterval(waitInterval);
          if (!this.invalidTools) {
            if (this.$store.getters.authUser) {
              NProgress.start();
              const CV = this.generateCv();
              this.$http({
                url: `/api/cv/${cv}`,
                method: "put",
                data: CV,
              }).then(res => {
                this.createdOrUpdated(res.data.updated, res.data.type, 'updated');
                this.saveTemplateImgAndPdf(res.data.updated);
              });
            } else {
              this.$store.commit('loginModal', true);
            }
          }
        }
      }, 1);
    },
    createdOrUpdated(cv, type, method) {
      this.$store.commit("newMessage", {
        show: true,
       type: "success",
        messageTitle: this.$store.getters.t("success"),
        message: this.$store.getters.t("save_resume")
      });
      NProgress.done();
      this.$router.push({
        name: 'cv-show-' + type,
        params: {
          lang: this.$store.getters.locale,
          cv: cv
        }
      });
    },
    getCv(cv) {
      this.$store.commit("loadEditCv", false);
      return new Promise((resolve, reject) => {
        this.$http({
          method: 'get',
          url: `/api/cv/${cv}/edit`
        }).then(res => {
          if (res.data.cv) {
            this.cv = res.data.cv.id;
            this.setCvState(res.data.cv);
            localStorage.setItem('skillIds', JSON.stringify(res.data.skillIds));
            localStorage.setItem('hobbiesIds', JSON.stringify(res.data.hobbiesIds));
            resolve({
              professionIds: res.data.professionIds,
            });
            this.$store.commit("loadEditCv", true);
          }
        });
      });
    },
    generateCv() {
      return {
        locale: this.$store.state.cv.cv_locale,
        name: this.$store.state.cv.name,
        surname: this.$store.state.cv.surname,
        photo: this.$store.state.cv.photo,
        date: this.$store.state.cv.date,
        career_objective: this.$store.state.cv.career_objective,
        phone: this.$store.state.cv.phone,
        email: this.$store.state.cv.email,
        address: this.$store.state.cv.address,
        job_stack: this.$store.state.cv.jobStack,
        job_stack_currency: this.$store.state.cv.jobStackCurrency,
        professions: this.$store.state.cv.cvProfessions,
        citizens: this.$store.state.cv.cvCitizens,
        skills: this.$store.state.cv.cvSkills,
        languages: this.$store.state.cv.cvLanguages,
        has_hobby: this.$store.state.cv.hasHobby,
        has_achievement: this.$store.state.cv.hasAchievement,
        hobbies: this.$store.state.cv.hobbies,
        educations: this.$store.state.cv.educations,
        has_experience: this.$store.state.cv.hasExperience,
        experiences: this.$store.state.cv.experiences,
        has_social: this.$store.state.cv.hasSocial,
        social_accounts: this.$store.state.cv.cvSocials,
        theme: this.$store.state.cv.cvTheme,
        type: this.$store.state.typeCv,
        achievement: this.$store.state.cv.achievement,
        pages: this.brs
      };
    },
    setCvState(cv) {
      this.$store.state.cv.cv_locale = cv.locale;
      this.$store.state.cv.date = cv.date;
      this.$store.state.cv.name = cv.name;
      this.$store.state.cv.surname = cv.surname;
      this.$store.state.cv.photo = cv.photo;
      this.$store.state.cv.career_objective = cv.career_objective;
      this.$store.state.cv.hasExperience = (cv.has_experience === '1');
      this.$store.state.cv.hasHobby = (cv.has_hobby === '1');
      this.$store.state.cv.hasAchievement = (cv.has_achievement === '1');
      this.$store.state.cv.hasSocial = (cv.has_social === '1');
      this.$store.state.cv.phone = cv.contacts.phone;
      this.$store.state.cv.email = cv.contacts.email;
      this.$store.state.cv.address = JSON.parse(cv.contacts.address);
      this.$store.state.cv.cvProfessions = cv.professions;
      this.$store.state.cv.cvCitizens = cv.citizens;
      this.$store.state.cv.cvSkills = cv.skills;
      this.$store.state.cv.cvLanguages = cv.languages;
      this.$store.state.cv.educations = cv.educations;
      this.$store.state.cv.experiences = cv.experiance;
      this.$store.state.cv.hobbies = cv.hobbies;
      this.$store.state.cv.jobStack = cv.job_stack;
      this.$store.state.cv.jobStackCurrency = cv.job_stack_currency;
      this.$store.state.cv.cvSocials = cv.social_accounts;
      this.$store.state.cv.cvTheme = cv.theme;
      this.$store.state.cv.achievement = cv.achievement;
      this.pages = cv.pages;
    },
    XFormatPrice(_number) {
      var decimal = 0;
      var separator = ' ';
      var decpoint = '.';
      var format_string = '#';

      var r = parseFloat(_number);

      var exp10 = Math.pow(10, decimal);// приводим к правильному множителю
      r = Math.round(r * exp10) / exp10;// округляем до необходимого числа знаков после запятой

      var rr = Number(r).toFixed(decimal).toString().split('.');

      var b = rr[0].replace(/(\d{1,3}(?=(\d{3})+(?:\.\d|\b)))/g, "\$1" + separator);

      var r = (rr[1] ? b + decpoint + rr[1] : b);

      return format_string.replace('#', r);
    },
    checkLocale(locale) {
      try {
        var tmpTranslations = require("../../../lang/" + locale);
      } catch (err) {
        return this.checkLocale(this.$store.getters.locale);
      }

      this.$Cookies.set("cv_locale", locale, {expires: 3});
      this.$store.commit("cv_locale", locale);
      this.$store.commit('cv_translation', tmpTranslations);
    },
    imageSetDefault() {
      if (this.$store.getters.authUser) {
        let avatar = this.$store.getters.user.avatar ? this.$store.getters.user.avatar.image : this.$store.getters.user.photo;
        if (avatar)
          this.$store.commit("cvPhoto", this.$store.getters.user.avatar ? this.$store.getters.user.avatar.image : this.$store.getters.user.photo);
        else
          this.$store.commit("cvPhoto", '/vue/images/user_img.jpg');
      }
    },
    openTab(name) {
      let tools = document.querySelectorAll('.show_tools .all_form_block');
      for (let i = 0; i < tools.length; i++) {
        tools[i].setAttribute('class', 'all_form_block');
      }
      document.querySelector('.show_tools .all_form_block[data-name="' + name + '"]').classList.add("active");
    },
    educationValidation() {
      this.waitEducation = true;
      if (
        this.$store.state.cv.tmpEducation.start &&
        this.$store.state.cv.tmpEducation.university &&
        this.$store.state.cv.tmpEducation.faculty &&
        this.$store.state.cv.tmpEducation.faculty.length > 2 &&
        this.$store.state.cv.tmpEducation.degree.id &&
        this.$store.state.cv.tmpEducation.specialization.id
      ) {
        document.getElementById('education').click();
        const count = this.$store.state.cv.educations.length;
        var interval = setInterval(() => {
          if (this.$store.state.cv.educations.length > count) {
            clearInterval(interval);
            this.educationCount = this.$store.state.cv.educations.length;
            this.waitEducation = false;
          }
        }, 1);
      } else {
        this.waitEducation = false;
        this.educationCount = this.$store.state.cv.educations.length;

        if (this.educationCount < 1 && !this.invalidTools) {
          this.addInvalidClass('cv-education');
        }
      }
    },
    experienceValidation() {
      if (
        this.$store.state.cv.tmpExperience.start &&
        this.$store.state.cv.tmpExperience.company &&
        this.$store.state.cv.tmpExperience.specialization.id
      ) {
        document.getElementById('experience').click();
      }
    },
    socialValidation() {
      if (
        this.$store.state.cv.tmpSocial.url
      ) {
        document.getElementById('social_add').click();
      }
    },
    changeKey() {
      this.key++;
    },
    checkCvPage(posY = 1132, lineClass = 'page-line', brClass = process.env.MIX_LINE_INTELLECT_BR, pageNumber = 1) {
      if (this.waitForAjax)
        return false;

      if (this.$refs.cvCraft === undefined) {
        setTimeout(() => {
          return this.checkCvPage();
        }, 50);
      }
      let line = document.getElementsByClassName(lineClass);

      while (line.length > 0) {
        line[0].parentNode.removeChild(line[0]);
      }

      if (this.$store.state.loadEditCv && this.$refs.cvCraft.clientHeight > posY) {
        if (line.length === 0) {
          let line = document.createElement("div");
          line.classList.add(lineClass);
          line.setAttribute("id", lineClass);
          line.style.top = (posY - 1) + 'px';
          this.$refs.cvCraft.appendChild(line);
        }

        let el = line[0].getBoundingClientRect();
        let elements = document.querySelectorAll(".small_section li");
        var element_index = null;
        this.parent_ul = null;
        this.store_name = null;

        for (let i = 0; i < elements.length; i++) {
          let top = elements[i].getBoundingClientRect().top,
            bottom = elements[i].getBoundingClientRect().bottom;
          if (el.y >= top && el.y <= bottom) {
            if (elements[i].textContent.split(' ')[0].trim() === brClass || elements[i].textContent.trim() === brClass) {
              return false;
            }
            element_index = Array.prototype.indexOf.call(elements[i].parentNode.children, elements[i]);
            this.store_name = elements[i].parentNode.dataset.name;
            this.parent_ul = elements[i].parentNode;
            break;
          }
        }
        if (typeof element_index === 'number') {
          if (this.store_name === 'hobbies') {
            var data = {
              c: 'Hobby'
            };
          }
          if (this.store_name === 'cvLanguages') {
            var data = {
              c: 'Language'
            };
          }
          if (this.store_name === 'cvSkills') {
            var data = {
              c: 'Skill'
            };
          }
          this.waitForAjax = true;
          this.$http({
            method: "post",
            url: '/api/cv/field-for-margin',
            data: data,
            responseType: "json"
          }).then(({data}) => {
            this.$store.state.cv.cvHobbies.map((value, key) => {
              if (value.title === brClass || value.name === brClass) {
                this.$store.state.cv.cvHobbies.splice(key, 1);
              }
            });
            this.$store.state.cv.cvLanguages.map((value, key) => {
              if (value.title === brClass || value.name === brClass) {
                this.$store.state.cv.cvLanguages.splice(key, 1);
              }
            });
            this.$store.state.cv.cvSkills.map((value, key) => {
              if (value.title === brClass || value.name === brClass) {
                this.$store.state.cv.cvSkills.splice(key, 1);
              }
            });
            this.$store.state.cv[this.store_name].splice(element_index, 0, data);
            this.key++;
            this.waitForAjax = false;
          });
        }
        if (this.parent_ul) {
          let first_child_y = this.parent_ul.children[0].getBoundingClientRect().y;
          if (el.y + 10 <= first_child_y) {
            this.$store.state.cv[this.store_name].map((value, key) => {
              if ((value.name !== undefined && value.name === brClass) || (value.title !== undefined && value.title === brClass)) {
                this.$store.state.cv[this.store_name].splice(key, 1);
              }
            });
          }
        }
      } else if (line.length) {
        document.getElementsByClassName(lineClass)[0].remove();
      }
    },
    checkCvPageLargeContent(removeBr = true, posY = 1132, lineClass = 'page-line', brClass = 'new-line-br', pageNumber = 1) {
      let brs = document.getElementsByClassName(brClass);

      if (removeBr) {
        while (brs.length > 0) {
          brs[0].parentNode.removeChild(brs[0]);
        }
      }

      let line = document.getElementsByClassName(lineClass);

      while (line.length > 0) {
        line[0].parentNode.removeChild(line[0]);
      }

      if (this.$refs.cvCraft !== undefined && this.$refs.cvCraft.clientHeight > posY) {
        if (line.length === 0) {
          let line = document.createElement("div");
          line.classList.add(lineClass);
          line.style.top = (posY - 1) + 'px';
          this.$refs.cvCraft.appendChild(line);
        }
        let elements = document.querySelectorAll(".large_section .large_section_line");
        var element_index = null;
        var call_self = false;
        for (let i = 0; i < elements.length; i++) {
          line = document.getElementsByClassName(lineClass);
          var el = line[0].getBoundingClientRect();
          let element_top_y = elements[i].getBoundingClientRect().top;
          let element_bottom_y = elements[i].getBoundingClientRect().bottom;
          if (el.y >= element_top_y && el.y <= element_bottom_y) {
            element_index = Array.prototype.indexOf.call(elements[i].parentNode.querySelectorAll('.large_section_line'), elements[i]);
            this.parent_ul = elements[i].parentNode;
            this.element = elements[i];
            this.element_index = element_index;
            call_self = true;
            break;
          }
        }

        if (Number.isInteger(element_index))
          var type = this.parent_ul.dataset.type;

        let newItem = document.createElement("p");
        newItem.classList.add(brClass);

        if (element_index === 0) {
          this.parent_index = Array.prototype.indexOf.call(this.parent_ul.parentNode.children, this.parent_ul);
          this.parent_ul.parentNode.insertBefore(newItem, this.parent_ul.parentNode.children[this.parent_index]);
          this.brs = {
            type,
            type_id: -1,
            count: brs.length - 1,
            page: pageNumber
          };
        } else if (element_index >= 1) {
          let new_index = Array.prototype.indexOf.call(this.element.parentNode.getElementsByClassName('large_section_line'), this.element);
          this.parent_ul.insertBefore(newItem, this.parent_ul.children[new_index + 1]);

          this.brs = {
            type,
            type_id: new_index,
            count: brs.length - 1,
            page: pageNumber
          };
        }

        if (call_self) {
          return this.checkCvPageLargeContent(false);
        }

        if (this.parent_ul) {
          var fake_y = el.y - 50,
            fake_parent_y = this.parent_ul.getBoundingClientRect().y - 20;

          if (fake_y <= this.parent_ul.getBoundingClientRect().y && el.y > fake_parent_y) {
            this.parent_ul.parentNode.insertBefore(newItem, this.parent_ul.parentNode.children[this.parent_index]);
            return this.checkCvPageLargeContent(false);
          }
        }

      } else if (line.length) {
        document.getElementsByClassName('page-line')[0].remove();
      } else {
        setTimeout(() => {
          return this.checkCvPageLargeContent();
        }, 50);
      }
    },
    checkPageTitle(remove = true) {
      let brs = document.getElementsByClassName('new-title-line-br');
      while (brs.length > 0 && remove) {
        brs[0].parentNode.removeChild(brs[0]);
      }

      let elements = document.querySelectorAll(".large_section_title"),
        call_self = false;
      var element_index = null;


      for (let i = 0; i < elements.length; i++) {
        let line = document.getElementsByClassName('page-line'),
          element_top_y = elements[i].getBoundingClientRect().y,
          element_bottom_y = element_top_y + elements[i].getBoundingClientRect().height;

        if (line.length === 0)
          return false;

        this.parent = null;
        let el = line[0].getBoundingClientRect();

        if (el.y >= element_top_y && el.y <= element_bottom_y + 50) {
          element_index = Array.prototype.indexOf.call(elements[i].parentNode.children, elements[i]);
          this.parent = elements[i].parentNode;
          this.element = elements[i];
          this.element_index = element_index;
          call_self = true;
          break;
        }
      }

      let newItem = document.createElement("p");
      newItem.classList.add('new-title-line-br');

      if (this.parent && this.parent.contains(this.element)) {
        this.parent.insertBefore(newItem, this.element);
      }

      if (call_self) {
        this.checkPageTitle(false);
      }

    },
    checkCvPage_2(removeBr = true, posY = 1132, lineClass = 'page-line', brClass = 'new-line-br', pageNumber = 1) {
      let line = document.getElementsByClassName(lineClass);
      let brs = document.getElementsByClassName(brClass);

      if (removeBr) {
        while (brs.length > 0) {
          brs[0].parentNode.removeChild(brs[0]);
        }
      }

      while (line.length > 0) {
        line[0].parentNode.removeChild(line[0]);
      }

      if (this.$store.state.loadEditCv && this.$refs.cvCraft.clientHeight > posY) {
        if (line.length === 0) {
          let line = document.createElement("div");
          line.classList.add(lineClass);
          line.setAttribute("id", lineClass);
          line.style.top = (posY - 1) + 'px';
          this.$refs.cvCraft.appendChild(line);
        }
        let elements = document.querySelectorAll(".large_section .large_section_line");
        var element_index = null;
        var call_self = false;
        var selected_elements = Array();
        for (let i = 0; i < elements.length; i++) {
          line = document.getElementsByClassName(lineClass);
          var el = line[0].getBoundingClientRect();
          let element_top_y = elements[i].getBoundingClientRect().top;
          let element_bottom_y = elements[i].getBoundingClientRect().bottom;
          if (el.y >= element_top_y && el.y <= element_bottom_y) {
            element_index = Array.prototype.indexOf.call(elements[i].parentNode.querySelectorAll('.large_section_line'), elements[i]);
            let info = {
              parent: elements[i].parentNode,
              element: elements[i],
              element_index: element_index
            };
            selected_elements.push(info);
            call_self = true;
          }
        }

        if (selected_elements.length) {
          this.selected_elements = selected_elements;
        }
        let newItem = document.createElement("p");
        newItem.classList.add(brClass);

        for (let i = 0; i < this.selected_elements.length; i++) {
          let elem = this.selected_elements[i];


          if (Number.isInteger(elem.element_index)) {
            var type = elem.parent.dataset.type;
          }

          if (elem.element_index === 0) {
            elem.parent.parentNode.insertBefore(newItem, elem.parent.parentNode.children[0]);

            this.brs[type] = {
              type,
              type_id: -1,
              count: brs,
              page: pageNumber
            };
          } else if (elem.element_index >= 1) {
            let new_index = Array.prototype.indexOf.call(elem.element.parentNode.getElementsByClassName('large_section_line'), elem.element);
            elem.parent.insertBefore(newItem, elem.parent.children[new_index]);
            let brs = elem.parent.parentNode.getElementsByClassName(brClass).length;
            this.brs[type] = {
              type,
              type_id: new_index,
              count: brs,
              page: pageNumber
            };
          }
        }

        if (call_self) {
          return this.checkCvPage_2(false);
        }

        this.brForFirstElement(el, newItem, brClass);
      }
    },

    brForFirstElement(el, newItem, brClass) {
      document.querySelectorAll('.large_section_title').forEach(section => {
        const sectionCordinateObject = section.getBoundingClientRect();
        if (el.top - sectionCordinateObject.top <= 31 && el.top - sectionCordinateObject.top >= -10) {
          const type = section.parentNode.parentNode.querySelector('.cv_them_block_one_blocks').dataset.type;
          const brs = section.parentNode.parentNode.getElementsByClassName(brClass).length;
          this.brs[type].count = brs + 2;
          section.parentNode.parentNode.insertBefore(newItem, section.parentNode.parentNode.children[0]);
          return this.checkCvPage_2(false);
        }
      });
    },

    cvSidebarPro2(posY = 1132, lineClass = 'page-line', brClass = process.env.MIX_LINE_INTELLECT_BR, pageNumber = 1) {
      if (this.$refs.cvCraft === undefined) {
        setTimeout(() => {
          return this.cvSidebarPro2();
        }, 50);
      }

      let line = document.getElementsByClassName(lineClass);

      while (line.length > 0) {
        line[0].parentNode.removeChild(line[0]);
      }

      if (this.$store.state.loadEditCv && this.$refs.cvCraft.clientHeight > posY) {
        if (line.length === 0) {
          let line = document.createElement("div");
          line.classList.add(lineClass);
          line.setAttribute("id", lineClass);
          line.style.top = (posY - 1) + 'px';
          this.$refs.cvCraft.appendChild(line);
        }

        let el = line[0].getBoundingClientRect();
        let elements = document.querySelectorAll(".small_section li");
        var element_index = null;
        this.parent_ul = null;
        this.store_name = null;
        var selected_elements = Array();
        var stop = [];
        for (let i = 0; i < elements.length; i++) {
          let top = elements[i].getBoundingClientRect().top,
            bottom = elements[i].getBoundingClientRect().bottom;
          if (el.y >= top && el.y <= bottom) {
            if (elements[i].textContent.split(' ')[2].trim() === brClass || elements[i].textContent.trim() === brClass) {
              stop.push(elements[i]);
            } else {
              element_index = Array.prototype.indexOf.call(elements[i].parentNode.children, elements[i]);
              let info = {
                parent: elements[i].parentNode,
                element: elements[i],
                element_index: element_index,
              };
              selected_elements.push(info);
              this.store_name = elements[i].parentNode.dataset.name;
            }
          }
        }
        if (stop.length > 1) {
          return false;
        }
        var alternative = false;
        if (typeof element_index === 'number') {
          if (this.store_name === 'hobbies') {
            var data = {
              c: 'Hobby'
            };
            alternative = true;
          }
          if (this.store_name === 'cvLanguages') {
            var data = {
              c: 'Language'
            };
            alternative = true;
          }
          if (this.store_name === 'cvSkills') {
            var data = {
              c: 'Skill'
            };
          }
          this.waitForAjax = true;
          this.$http({
            method: "post",
            url: '/api/cv/field-for-margin',
            data: data,
            responseType: "json"
          }).then(({data}) => {

            this.$store.state.cv.cvHobbies.map((value, key) => {
              if (value.title === brClass || value.name === brClass) {
                this.$store.state.cv.cvHobbies.splice(key, 2);
              }
            });
            this.$store.state.cv.cvLanguages.map((value, key) => {
              if (value.title === brClass || value.name === brClass) {
                this.$store.state.cv.cvLanguages.splice(key, 2);
              }
            });
            this.$store.state.cv.cvSkills.map((value, key) => {
              if (value.title === brClass || value.name === brClass) {
                this.$store.state.cv.cvSkills.splice(key, 1);
              }
            });

            if (alternative && selected_elements.length) {
              this.$store.state.cv[this.store_name].splice(selected_elements[0].element_index, 0, data);
              this.$store.state.cv[this.store_name].splice(selected_elements[0].element_index, 0, data);
            }

            if (!alternative) {
              this.$store.state.cv[this.store_name].splice(element_index, 0, data);
            }

            this.key++;
            this.waitForAjax = false;
          });
        }

      }
    },
    checkCvPageLargeContentUltra2(removeBr = true, posY = 1132, lineClass = 'page-line', brClass = 'new-line-br', pageNumber = 1) {
      let brs = document.getElementsByClassName(brClass);

      if (removeBr) {
        while (brs.length > 0) {
          brs[0].parentNode.removeChild(brs[0]);
        }
      }

      let line = document.getElementsByClassName(lineClass);

      while (line.length > 0) {
        line[0].parentNode.removeChild(line[0]);
      }

      if (this.$refs.cvCraft !== undefined && this.$refs.cvCraft.clientHeight > posY) {
        if (line.length === 0) {
          let line = document.createElement("div");
          line.classList.add(lineClass);
          line.style.top = (posY - 1) + 'px';
          this.$refs.cvCraft.appendChild(line);
        }
        let elements = document.querySelectorAll(".large_section .large_section_line");
        var element_index = null;
        var call_self = false;
        for (let i = 0; i < elements.length; i++) {
          line = document.getElementsByClassName(lineClass);
          var el = line[0].getBoundingClientRect();
          let element_top_y = elements[i].getBoundingClientRect().top;
          let element_bottom_y = elements[i].getBoundingClientRect().bottom;
          if (el.y >= element_top_y && el.y <= element_bottom_y) {
            element_index = Array.prototype.indexOf.call(elements[i].parentNode.querySelectorAll('.large_section_line'), elements[i]);
            this.parent_ul = elements[i].parentNode.parentNode;
            this.element = elements[i];
            this.element_index = element_index;
            call_self = true;
            break;
          }
        }

        if (Number.isInteger(element_index))
          var type = this.parent_ul.dataset.type;

        let newItem = document.createElement("p");
        newItem.classList.add(brClass);

        if (element_index === 0) {
          this.parent_index = Array.prototype.indexOf.call(this.parent_ul.parentNode.children, this.parent_ul);
          this.parent_ul.parentNode.insertBefore(newItem, this.parent_ul.parentNode.children[this.parent_index]);

          this.brs = {
            type,
            type_id: -1,
            count: brs.length,
            page: pageNumber
          };
        } else if (element_index >= 1) {
          this.parent_ul = this.parent_ul.children[1];
          let new_index = Array.prototype.indexOf.call(this.element.parentNode.getElementsByClassName('large_section_line'), this.element);
          this.parent_ul.insertBefore(newItem, this.parent_ul.children[new_index]);
          this.brs = {
            type,
            type_id: new_index,
            count: brs.length,
            page: pageNumber
          };
        }

        if (call_self) {
          return this.checkCvPageLargeContentUltra2(false);
        }

        if (this.parent_ul) {
          var fake_y = el.y - 50,
            fake_parent_y = this.parent_ul.getBoundingClientRect().y - 20;

          if (fake_y <= this.parent_ul.getBoundingClientRect().y && el.y > fake_parent_y) {
            this.parent_ul.parentNode.insertBefore(newItem, this.parent_ul.parentNode.children[this.parent_index]);
            return this.checkCvPageLargeContent(false);
          }
        }

      } else if (line.length) {
        document.getElementsByClassName('page-line')[0].remove();
      } else {
        setTimeout(() => {
          return this.checkCvPageLargeContentUltra2();
        }, 50);
      }
    },
    lineBr(item) {
      return {'margin-field': (item.name === this.MIX_LINE_INTELLECT_BR || item.title === this.MIX_LINE_INTELLECT_BR)};
    },
    isTmpExperience() {
      return (!this.$store.state.cv.experiences.length || this.writeExperience) && !Number.isInteger(this.$store.state.cv.tmpExperienceEditIndex);
    },
    isTmpEducation() {
      return (!this.$store.state.cv.educations.length || this.writeEducation) && !Number.isInteger(this.$store.state.cv.tmpEducationEditIndex);
    },
    getCircleColor(cv_type) {
      let color = "#5d5e5e";
      if (!cv_type || !this.$store.state.cv.cvTheme.class_name)
        return color;
      switch (cv_type) {
        case 'p-2':
          switch (this.$store.state.cv.cvTheme.class_name) {
            case 'them_1':
              color = "#5d5e5e";
              break;
            case 'them_2':
              color = "#f05a38";
              break;
            case 'them_3':
              color = "#ed1c3f";
              break;
            case 'them_4':
              color = "#e7de2c";
              break;
            case 'them_5':
              color = "#f05a38";
              break;
          }
          break;
        case 'u-1':
          switch (this.$store.state.cv.cvTheme.class_name) {
            case 'them_1':
              color = "#5d5e5e";
              break;
            case 'them_2':
              color = "#6c6c6c";
              break;
            case 'them_3':
              color = "#efdf00";
              break;
            case 'them_4':
              color = "#a21271";
              break;
            case 'them_5':
              color = "#f0b90d";
              break;
          }
          break;
        case 'u-2':
          switch (this.$store.state.cv.cvTheme.class_name) {
            case 'them_1':
              color = "#ca34d6";
              break;
            case 'them_2':
              color = "#303030";
              break;
            case 'them_3':
              color = "#efa16c";
              break;
            case 'them_4':
              color = "#ffd350";
              break;
            case 'them_5':
              color = "#e59a17";
              break;
          }
          break;
      }
      // console.log(this.$store.state.cv.cvTheme.class_name);
      // console.log(color);
      return color;
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/components/pages/cv/cv-functions.js